import { Link } from 'react-router';
import { useFeedbackRecord } from '../../components/feedback-context.ts';
import { Page, Title } from '../../components/ui.tsx';
import { Articles } from '../Blog.tsx';

/**
 * Settings → Development tools → Development blog (Jason, 2026-10-04:
 * "shouldn't the development blog be visible on the dev side too?"): every
 * release in plain words, as the public blog has them. Production keeps them,
 * each recorded as it shipped; a development build reads production's, so
 * they are here on this machine too.
 */
export function DevelopmentBlog() {
  useFeedbackRecord(null, null);
  return (
    <Page>
      <Title kicker="Settings · development tools">The development blog</Title>
      <p className="max-w-measure text-ink-2">
        What each release changed, what it added and what it fixed, written as it shipped. The same articles are public at{' '}
        <Link to="/blog" className="link">
          the blog
        </Link>
        , linked from the sign-in page.
      </p>
      <div className="max-w-column">
        <Articles />
      </div>
    </Page>
  );
}
